import React, { useEffect, useState } from 'react'
import cls from 'classnames'

import {
  HEBREW_LOCALE_CONST,
  LABELS,
  ORDER,
} from 'containers/Settings/MailboxProtection/LandingForm/constants'

import Button from 'components/lib/DesignSystem/Button'
import { Refresh } from 'components/lib/DesignSystem/Icons'
import Select from 'components/lib/DesignSystem/Select'

require('components/styles/layouts/settings/landingForm.styl')

const Field = (props) => (
  <div className="landing-form-field">
    <Button
      text="Default"
      LeftIconDS={Refresh}
      dsIconStyles={{ fill: '#0152CC' }}
      styleType="tertiary"
      className="fr"
      onClick={() => props.handleOnChange(props.mainKey, props.objKey, props.default, props.locale)}
      id={props.objKey && `${props.objKey}_default_button`}
    />
    <div className="lff-label">{props.label}</div>
    <props.field
      rows={props.field === 'textarea' ? '6' : '1'}
      id={props.objKey}
      className={cls('lff-input', {
        rtl: props.locale === HEBREW_LOCALE_CONST,
      })}
      type="text"
      value={props.value}
      onChange={(e) =>
        props.handleOnChange(props.mainKey, props.objKey, e.target.value, props.locale)
      }
    />
  </div>
)

function LandingForm({
  data,
  permissions,

  getLandingPages,
  getLandingPagesCancel,
  updLandingPages,
  inputChangeHandler,

  isGroupSettings,
  groupSettingsNameByPartner,

  isStaticSalesDemo,
  defaultLanguage,
}) {
  const [selectedLang, changeSelectedLang] = useState(null)

  useEffect(() => {
    if (!data.languages && !isGroupSettings) getLandingPages()
    if (!selectedLang) {
      changeSelectedLang(data.languages?.find((elem) => elem.default)?.id)
    }
    return () => !isGroupSettings && getLandingPagesCancel()
  }, [data])

  const handleLanguageChange = (obj) => changeSelectedLang(obj || selectedLang)

  const handleOnChange = (mainKey, objKey, value, locale) => {
    inputChangeHandler(mainKey, objKey, value, locale)
  }

  const languageOptions = data.languages
    ?.filter((elem) => elem.enabled)
    .map((l) => ({ value: l.id, label: l.name }))

  const getSortedData = (obj) => obj && Object.keys(obj).sort((a, b) => ORDER[a] - ORDER[b])

  const bannersData = getSortedData(data.main)
  const emailConfirmationData = getSortedData(data.confirmed)

  const languageValue = languageOptions?.filter((e) => e.value === selectedLang).length
    ? selectedLang
    : defaultLanguage.name

  return (
    <div
      className={cls('landing-form', {
        disabled_for_edit: groupSettingsNameByPartner,
      })}
    >
      <div className="title">KNOWN SENDER - LANDING PAGES</div>
      <div className="row-container">
        <div className="sub-title">Modify language for known sender landing pages</div>
        <div className="select-container">
          <Select
            className="is-select"
            placeholder="Select default language"
            value={languageValue}
            options={languageOptions}
            onSelect={handleLanguageChange}
            optionFilterProp="label"
            id="knownSenderLandingPagesLanguage"
          />
        </div>
      </div>
      <div className="title">Banner landing page</div>
      <div>
        {bannersData?.map((elem) => {
          const localizedBannerText =
            data.main[elem].localized[selectedLang] ||
            data.main[elem].default[selectedLang] ||
            data.main[elem].default[1]
          const dataDefaultByLocale =
            data.main[elem].default[selectedLang] || data.main[elem].default[1]
          return (
            <Field
              key={elem}
              objKey={elem}
              mainKey="main"
              label={LABELS[elem]}
              default={dataDefaultByLocale}
              value={localizedBannerText}
              field={elem.indexOf('paragraph') !== -1 ? 'textarea' : 'input'}
              handleOnChange={handleOnChange}
              locale={selectedLang}
            />
          )
        })}
        <div className="title">Email Confirmation Landing Page</div>
        {emailConfirmationData?.map((elem) => {
          const localizedBannerText =
            data.confirmed[elem].localized[selectedLang] ||
            data.confirmed[elem].default[selectedLang] ||
            data.confirmed[elem].default[1]
          const dataDefaultByLocale =
            data.confirmed[elem].default[selectedLang] || data.confirmed[elem].default[1]
          return (
            <Field
              key={elem}
              objKey={elem}
              mainKey="confirmed"
              label={LABELS[elem]}
              default={dataDefaultByLocale}
              value={localizedBannerText}
              field={elem.indexOf('paragraph') !== -1 ? 'textarea' : 'input'}
              handleOnChange={handleOnChange}
              locale={selectedLang}
            />
          )
        })}
      </div>
      {!isGroupSettings && (
        <div className="save-button-container">
          <Button
            text="Save Landing Pages"
            disabled={!permissions.admin || groupSettingsNameByPartner || isStaticSalesDemo}
            onClick={updLandingPages}
            id="knownSenderLandingPagesSaveButton"
          />
        </div>
      )}
    </div>
  )
}

export default LandingForm
